import React from 'react';
import {
    COVER_DISPLAY_FONT_VAR,
    CoverLogo,
    coverPsychologistLine,
    coverTitleSize,
    type CoverTemplateProps,
} from './shared';

const INK = '#2e2b26';
const DIM = '#6f675b';

/**
 * Papelaria fina: moldura dupla, creme quente com grafite, paciente em
 * itálico serifado. Paleta própria — ignora as cores da marca de propósito.
 */
export const Papelaria: React.FC<CoverTemplateProps> = ({ fields, logoUrl, showLogo }) => {
    const psychologist = coverPsychologistLine(fields);
    const dimLines = [fields.solicitante, psychologist || undefined, fields.city_date].filter(
        Boolean,
    );

    return (
        <div className="size-full bg-[#f7f4ee] p-[1.3em]" style={{ color: INK }}>
            <div
                className="h-full border-2 p-[6px]"
                style={{ borderColor: 'rgba(46, 43, 38, 0.75)' }}
            >
                <div
                    className="flex h-full flex-col items-center border px-[2em] pb-[2.2em] pt-[2.6em] text-center"
                    style={{ borderColor: 'rgba(46, 43, 38, 0.4)' }}
                >
                    <CoverLogo logoUrl={logoUrl} showLogo={showLogo} />
                    <div className="my-auto flex flex-col items-center">
                        {fields.subtitle ? (
                            <div
                                className="uppercase tracking-[0.38em]"
                                style={{ fontSize: coverTitleSize(0.58), color: DIM }}
                            >
                                {fields.subtitle}
                            </div>
                        ) : null}
                        <div className="my-[1.6em] flex items-center gap-[0.7em] text-[#8c7a5b]">
                            <span className="h-px w-[3.4em] bg-[rgba(140,122,91,0.6)]" />
                            <span className="text-[0.55em]">◆</span>
                            <span className="h-px w-[3.4em] bg-[rgba(140,122,91,0.6)]" />
                        </div>
                        <div
                            className="font-bold leading-[1.1] tracking-[0.01em]"
                            style={{
                                fontFamily: COVER_DISPLAY_FONT_VAR,
                                fontSize: coverTitleSize(2.5),
                            }}
                        >
                            {fields.document_title}
                        </div>
                    </div>
                    {fields.patient_name || dimLines.length > 0 ? (
                        <div className="text-[0.62em] leading-[1.8]" style={{ color: DIM }}>
                            {fields.patient_name ? (
                                <div
                                    className="mb-[0.4em] text-[1.35em] italic"
                                    style={{ fontFamily: COVER_DISPLAY_FONT_VAR, color: INK }}
                                >
                                    {fields.patient_name}
                                </div>
                            ) : null}
                            {dimLines.map((line) => (
                                <div key={line}>{line}</div>
                            ))}
                        </div>
                    ) : null}
                </div>
            </div>
        </div>
    );
};
